module.exports = __webpack_public_path__ + "static/media/angle-down.391bb53a.svg";